export default __webpack_public_path__ + "static/media/ic-crops-cabbage.a4e0a6f7.png";